import type { ProgramDay } from '../types';

export const programData: ProgramDay[] = [
  {
    date: '26. decembris',
    day: 'Piektdiena',
    activities: [
      {
        time: '11:00',
        title: 'Ierašanās un Radošās Darbnīcas',
        description: 'Iepazīšanās un radošo darbnīcu iesākšana',
        type: 'day-camp',
        icon: 'Palette',

        ageGroup: 'Visiem'
      },
      {
        time: '12:00',
        title: 'Uzkodas',
        description: 'Visi dalībnieki aicināti izbaudīt garšīgas bulciņas un svaigus augļus.',
        type: 'day-camp',
        icon: 'Coffee', // Using Coffee as generic snack/break icon

        ageGroup: 'Visiem'
      },
      {
        time: '13:00',
        title: 'Orientēšanās pa Pilsētu "Kur tas ir?"',
        description: 'Dalībnieki, kuri vēlēsies, tiks sadalīti komandās un saņems komandas karti aizraujošai orientēšanās spēlei, kurā būs jāmeklē, jāskrien un jāatrod visas norādītās vietas pilsētas maršrutā! (Ieteicamais vecums: 10–16 gadi.)',
        type: 'day-camp',
        icon: 'Map',

        ageGroup: 'Ieteicams 10‑16 gadiem',
      },
      {
        time: '15:30',
        title: 'Grilētas Vakariņas',
        description: 'Visi dalībnieki aicināti izbaudīt garšīgas grilētas vakariņas ar salātiem',
        type: 'day-camp',
        icon: 'Utensils',

        ageGroup: 'Visiem'
      },
      {
        time: '16:30',
        title: 'Komandas Spēles Mežā',
        description: 'Dalībnieki, kuri vēlēsies, varēs izbaudīt, kā ir, kad mežs kļūst par spēles laukumu! Slēpšanās un meklēšanas meistarklase komandās. (Ieteicamais vecums: 10–16 gadi.)',
        type: 'day-camp',
        icon: 'Trees',

        ageGroup: 'Ieteicams 10‑16 gadiem',

      },
      {
        time: '19:00',
        title: 'Vakara Noslēgums',
        description: 'Ziemassvētku vēsts ar dziesmām un dāvanu katram dalībniekam.',
        type: 'day-camp',
        icon: 'Gift',

        ageGroup: 'Visiem'
      }
    ]
  }
];
